import styles from "../index.module.css";

const FieldExecutiveDashboard = () => {
  return <div className={styles["dashboard-title"]}>Dashboard</div>;
};

export default FieldExecutiveDashboard;
